export const WB_COUNTERPARTY_NAME = 'WILDBERRIES'.toLocaleLowerCase();
